import React from 'react';
import PropTypes from 'prop-types';

const ViewNavExtra = ({ children }) => <div>{children}</div>;

ViewNavExtra.propTypes = {
  children: PropTypes.node,
};

export default ViewNavExtra;



// WEBPACK FOOTER //
// ./components/ViewNav/ViewNavExtra/index.jsx